export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover esta locação para o carro com a placa <b>${this.currentEntity.car.plate}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/rent-parking/resources/computed.js